














































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { abnormalOverview, abnormalParkRanking } from '@/api/statistic-analysis/index';
@Component({
  components: {}
})
export default class rightTop extends Vue {
  //选中的车场ids
  @Prop({ default: () => [] })
  selectParkIds: any[];
  // //loading
  // @Prop({ default: false })
  // rankLoading: boolean
  // //列表
  // @Prop({ default: () => [] })
  // rankList: any[]

  //搜索条件
  @Prop({ default: () => {} })
  filterParam: any;

  typeOptions: any[] = [
    { value: '00', text: '手动抬杆' },
    { value: '01', text: '特殊放行' },
    { value: '02', text: '车辆修正' }
  ];
  abnormalType: string = '00';
  rankLoading: boolean = false;
  rankList: any[] = [];
  changeAbnormal() {
    this.getParkRanking();
  }
  //排名
  async getParkRanking() {
    this.$emit('getParams');
    try {
      if (this.rankLoading) return;
      this.rankLoading = true;
      let json = { ...this.filterParam, sort: this.abnormalType };
      const { data } = await abnormalParkRanking(json);
      this.rankList = data;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.rankLoading = false;
    }
  }
  changeType() {
    this.abnormalType = '00';
    this.getParkRanking();
  }
}
